<template>
  <!-- 新增标签 -->
  <a-modal :visible="visible" title="新增标签" :closable="false" :afterClose="handleCancel" width="530px">
    <a-form-model ref="formDom" :rules="rules" :model="form" :label-col="{span: 4}" :wrapper-col="{span: 20}">
      <a-form-model-item label="发布平台" prop="line_id">
        <a-cascader v-model="lines_id" popupClassName="org" :options="options" change-on-select placeholder="请选择" @change="orgChange" />
      </a-form-model-item>
      <a-form-model-item label="标签名称" prop="label_name">
        <a-input v-model.trim="form.label_name" :maxLength="32" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="声母" prop="initial_consonant">
        <a-input v-model.trim="form.initial_consonant" @change="onChange" :maxLength="32" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="模块类型" prop="module">
        <a-radio-group v-model="form.module" allowClear show-search placeholder="请选择">
          <a-radio v-for="(item, index) in LABEL_MODULE" :key="item.key" :value="item.key">{{ item.value }}<span v-if="index===1"> (仅限用于集团内站)</span></a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="推荐" prop="is_recommend">
        <a-radio-group v-model="form.is_recommend">
          <a-radio v-for="item in ARTICLE_ISCOMMEND" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="置顶" prop="is_top">
        <a-radio-group v-model="form.is_top">
          <a-radio v-for="item in ARTICLE_IS_TOP" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取 消
      </a-button>
      <a-button key="submit" type="primary" :loading="btnLoading" @click="handleSubmit">
        提 交
      </a-button>
    </template>
  </a-modal>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed, watch } from '@vue/composition-api'
import { rules, form } from './business/tagList'
import pagination from '@/composables/pagination'
import compuedFun from './index'
import api from '@/api/'

export default {
  setup(label) {
    // 获取当前实例
    const _this = getCurrentInstance()
    const lineId = computed(() => _this.$route.query.line_id)
    // 分页信息

    const state = reactive({
      rules,
      options: [], // 业务线
      cascader: [], // 级联选择-搜索
      btnLoading: false, // 按钮loading
      form: { ...form },
      optionsList: [], // 业务线接口数据
      lines_id: [],
      visible: false,
    })

    onMounted(async () => {
      const line_id = lineId.value
      await methods.getPlatform()
      const arr = []
      state.options.find((item) => {
        if (line_id && item.value === parseInt(line_id)) {
          arr.push(item)
        }
      })
      state.options = arr
    })

    const methods = {
      orgChange(val) {
        state.form.line_id = val[val.length - 1]
      },

      changeV() {
        _this.visible = true
      },

      // 声母过滤,只能输入大小写字母
      onChange(e) {
        state.form.initial_consonant = e.target.value.replace(/[^a-z]/gi, '')
      },

      // 获取平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.optionsList = res.data
        res.data.filter((item) => {
          if (item.parent_id === 0) {
            const params = {
              value: parseInt(item.id),
              label: item.name,
            }
            state.options.push(params)
          }
        })
        state.options.map((item) => {
          this.getDepartmentTree(res.data, item)
        })
      },
      // 过滤平台列表
      getDepartmentTree(originList, listItem) {
        const hasChildren = originList.every((item) => listItem.value !== item.parent_id)
        if (!hasChildren) {
          listItem.children = []
        } else {
          return false
        }
        originList.map((item) => {
          if (listItem.value === item.parent_id) {
            const params = {
              value: parseInt(item.id),
              label: item.name,
              name: item.name,
            }
            listItem.children.push(params)
            this.getDepartmentTree(originList, params)
          }
        })
      },

      // 关闭弹窗
      handleCancel() {
        state.lines_id = []
        _this.visible = false
        _this.$refs.formDom.resetFields()
      },

      // 提交编辑
      handleSubmit() {
        _this.$refs.formDom.validate(async (valid) => {
          if (valid) {
            const arr = await Promise.all([
            api.forbiddenWordsArticle({ content: state.form.label_name, module: 2 }),
            ])
            if (/#F00/g.test(arr[0].data.content)) {
            _this.$confirm({
              content: '存在为违禁词,请确认是否提交？',
              async onOk() {
                _this.submit()
              },
            })
            } else {
             _this.submit()
            }
          }
        })
      },
      async submit() {
        state.btnLoading = true
        const res = await api.createLabel(state.form)
        if (_this.$validate(res)) {
          this.$message.success('新增成功~')
          this.$emit('getLable', res.data.label)
          _this.visible = false
        }
        state.btnLoading = false
      },
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...pagination(),
      ...methods,
    }
  },
}
</script>
